import {HOGARREDUCER} from '../types';

export const hogarAction = ( data ) => async (dispatch) =>{

  dispatch({
      type: HOGARREDUCER,
      payload: data
  });

}